import React, { Component } from "react";

class Devsolucoes extends Component {

    render() {
        return(
            <React.Fragment>
                <section class="dev-solucoes">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                            <h2>Desenvolvemos soluções que podem ser aplicadas em vários segmentos</h2>
                            </div>

                            <div class="col-12 col-lg-4 px-5">
                            <div class="cartao">
                                <div class="cartao__side cartao__side--front-2">
                                    <div class="cartao__title cartao__title--1">
                                        <img src={"../assets/img/ico-saude.svg"} alt="Icone para Desenvolvimento de Solução para Saúde."></img>
                                        <h4 class="cartao__heading">Saúde</h4>
                                    </div>

                                    <div class="cartao__details">
                                    </div>
                                </div>
                                
                                <div class="cartao__side cartao__side--back cartao__side--back-1">
                                    <div class="cartao__cta">
                                        <div class="cartao__content-box">
                                        <p class="cartao__content-title">Soluções</p>
                                        </div>
                                        <div class="lista-item">
                                        <ul>
                                            <li>Monitoramento de Temperatura e Umidade</li>
                                            <li>Gestão de Ocupação de Leitos</li>
                                            <li>Rastreabilidade de Equipamentos</li>
                                            <li>Gestão de Processo de Limpeza</li>
                                            <li>Atendimento de Check-up</li>
                                            <li>Soluções RFID</li>
                                            <li>Atendimento em Clínicas Radiológicas</li>
                                        </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>

                            <div class="col-12 col-lg-4 px-5">
                            <div class="cartao">
                                <div class="cartao__side cartao__side--front-2">
                                    <div class="cartao__title cartao__title--1">
                                        <img src={"../assets/img/ico-hotelaria.svg"} alt="Icone para Desenvolvimento de Solução para Hotelaria."></img>
                                        <h4 class="cartao__heading">Hotelaria</h4>
                                    </div>

                                    <div class="cartao__details">
                                    </div>
                                </div>
                                
                                <div class="cartao__side cartao__side--back cartao__side--back-1">
                                    <div class="cartao__cta">
                                        <div class="cartao__content-box">
                                        <p class="cartao__content-title">Soluções</p>
                                        </div>
                                        <div class="lista-item">
                                        <ul>
                                            <li>Gestão de Processo de Limpeza</li>
                                        <li>Soluções RFID</li>
                                        </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>

                            <div class="col-12 col-lg-4 px-5">
                            <div class="cartao">
                                <div class="cartao__side cartao__side--front-2">
                                    <div class="cartao__title cartao__title--1">
                                        <img src={"../assets/img/ico-varejo.svg"} alt="Icone para Desenvolvimento de Solução para Varejo."></img>
                                        <h4 class="cartao__heading">Varejo</h4>
                                    </div>

                                    <div class="cartao__details">
                                    </div>
                                </div>
                                
                                <div class="cartao__side cartao__side--back cartao__side--back-1">
                                    <div class="cartao__cta">
                                        <div class="cartao__content-box">
                                        <p class="cartao__content-title">Soluções</p>
                                        </div>
                                        <div class="lista-item">
                                        <ul>
                                            <li>Monitoramento de Temperatura e Umidade</li>
                                        </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

export default Devsolucoes;